import axios from "const/axios";

// ========= Company profile (settings) =========

export const getCompanyProfile = async () => {
  const res = await axios.get("company-profile");
  return res?.data?.data ?? res?.data;
};

export const addCompanyProfile = async (payload) => {
  const res = await axios.post("company-profile", payload);
  return res?.data?.data ?? res?.data;
};
export const updateCompanyProfile = async (payload) => {
  const res = await axios.put(`company-profile`, payload);
  return res?.data?.data ?? res?.data;
};
